import React, { useMemo } from 'react';
import { Button, Flex } from 'onefaceui-react-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { actionCreators } from 'react/api/actions/header';
import { getResourceTo } from 'react/utils/utils';
import { ActivityCenterHeader } from './ActivityCenterHeader';
import { ActivityCenterContent } from './ActivityCenterContent';

function ActivityCenterContainer({ items }) {
  const dispatch = useDispatch();

  const totalNewNotifications = useMemo(
    () => items.filter((item) => !item.isRead).length,
    []
  );

  return (
    <Flex
      dataTestId="activityCenter-container"
      flexDirection="column"
      className="activityCenterContainer"
    >
      <ActivityCenterHeader
        totalNotifications={items.length}
        newNotifications={totalNewNotifications}
      />
      <ActivityCenterContent items={items} />
      <Flex
        justifyContent="flex-end"
        gap={8}
        alignItems="center"
        className="activityCenterFooter"
        dataTestId="activityCenter-footer"
      >
        <Button
          dataTestId="activityCenter-close"
          variant="secondary"
          onClick={() => dispatch(actionCreators.selectRightOptionsItem(null))}
        >
          {getResourceTo('default.button.close')}
        </Button>
      </Flex>
    </Flex>
  );
}

ActivityCenterContainer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
};

ActivityCenterContainer.defaultProps = {
  items: []
};

export default ActivityCenterContainer;
